// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const JobDrawer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
JobDrawer.displayName = 'S.JobDrawer';

export const JobDrawerMain = styled.div`
  flex: 1 1 auto;
`;
JobDrawerMain.displayName = 'S.JobDrawerMain';

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  white-space: wrap;
  overflow: hidden;
`;
Header.displayName = 'S.Header';

export const CloseButton = styled.div`
  text-align: right;
  flex: 1 1 auto;
`;
CloseButton.displayName = 'S.CloseButton';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
Label.displayName = 'S.Label';

export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const VersionDescription = styled.div`
  max-width: 600px;
  max-height: 400px;
  overflow: scroll;
  font-size: 14px;
`;
VersionDescription.displayName = 'S.VersionDescription';
